










import {Vue, Component, Prop} from 'vue-property-decorator';
import {PremiumExcelCreateMenu} from 'supporter';
import ServerExcelReasonLayerPopup from '@/views/excel/popup/ServerExcelReasonLayerPopup.vue';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';

@Component({
  components: {ServerExcelReasonLayerPopup: ServerExcelReasonLayerPopup}
})
export default class ExcelCreateButton extends Vue {
  /**
   * @excelCreateMenuKey
   *
   * PostExcelsRequest.params.menu 로 들어갈 값
   */
  @Prop({required: false, default: undefined})
  private readonly excelCreateMenuKey!: PremiumExcelCreateMenu | undefined;
  @Prop({required: true})
  private readonly hasData!: boolean;
  @Prop({required: true})
  private readonly createExcelFileQuery: {[key: string]: any};
  @Prop({required: false})
  private readonly extraInfo!: string;
  @Prop({required: false})
  private readonly buttonName!: string;
  @Prop({required: false})
  private readonly checkExcelDownValidation: (() => boolean) | null;

  get getButtonName(): string {
    if (this.buttonName) {
      return this.$t(this.buttonName).toString();
    } else {
      return this.$t('CREATE').toString();
    }
  }

  get menuKey(): PremiumExcelCreateMenu {
    return this.excelCreateMenuKey ?? this.$route.meta.excelCreateMenuKey;
  }

  private onCreateExcel(): void {
    if (typeof this.checkExcelDownValidation === 'function' && !this.checkExcelDownValidation()) {
      return;
    }

    createExcel(this, this.hasData, this.createExcelFileQuery, this.excelCreateMenuKey, this.extraInfo);
  }
}
